import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';
import { OutingService } from '../../services/outing.service';
import { PublicOutingRsvp } from '../../models/outing.model';

// Public, token-based RSVP page (no auth) — reached from the "Confirm attendance"
// button in the invitation email. Mirrors the exit-questionnaire public-page pattern.
@Component({
  selector: 'app-outing-rsvp',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './outing-rsvp.component.html',
  styleUrl: './outing-rsvp.component.scss'
})
export class OutingRsvpComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private route = inject(ActivatedRoute);
  private outingService = inject(OutingService);

  token = '';
  invite: PublicOutingRsvp | null = null;
  loading = true;
  notFound = false;
  confirming = false;
  confirmed = false;

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    if (!this.token) {
      this.loading = false;
      this.notFound = true;
      return;
    }

    this.outingService.getRsvp(this.token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.invite = data;
          this.confirmed = data.alreadyConfirmed;
          this.loading = false;
        },
        error: () => {
          this.notFound = true;
          this.loading = false;
        }
      });
  }

  confirm(): void {
    if (this.confirming || this.confirmed) return;
    this.confirming = true;
    this.outingService.confirmRsvp(this.token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.invite = data;
          this.confirmed = true;
          this.confirming = false;
        },
        error: () => {
          this.confirming = false;
        }
      });
  }
}
